import React from 'react';
import './contactanos.css'; // Importando el archivo de estilos
import CustomQR from './CustomQR';

export const Contactanos = () => {
  return (
    <div>
      {/* Sección para Dueños de Salones */}
      <div className="section-owner">
        <div>
          <h2>¿Eres dueño de un salón?</h2>
          <p>
            ¡Haz crecer tu negocio con nosotros! Llega a miles de clientes que buscan el espacio perfecto
            para su evento. Contáctanos directamente para más información y empezar a promocionar tu salón.
          </p>
          
          {/* Llamada o WhatsApp */}
          <div className="contact-options">
            <a 
              href="tel:+525585170439" 
              className="contact-button"
            >
              📞 Llama al 55 85 17 04 39
            </a>
            <a 
              href="https://wa.me/525585170439" 
              className="contact-button"
            >
              💬 Escríbenos por WhatsApp
            </a>
          </div>
        </div>
      </div>

      {/*<CustomQR url='https://enfiestandonos.com/espacios-para-tu-evento/jardin/santa-maria/1' size={250}/>*/}
    </div>
  );
};
